import { Component, Input } from '@angular/core';

@Component({
  selector: 'common-tiktok-icon',
  templateUrl: './tiktok-icon.component.svg',
})
export class TiktokIconComponent {
  @Input() color = '#343E57';
  @Input() width = 18;
  @Input() height = 20;
}
